export default "__VITE_ASSET__DbNP_meX__"